import useStatusPill from '@hooks/useStatusPill'
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Sheet slides out in 320ms; going back a little before it ends reads as one motion.
const SHEET_EXIT_MS = 300
// Roughly how long the previous screen's slide-in spring takes to settle.
export const BACK_SETTLE_MS = 200

/**
 * Returns a function that goes back (or to `to`) once a sheet closed in the same tick has slid out,
 * then shows the status pill on the screen the user lands on.
 */
export const useBackAfterSheet = (to?: string) => {
  const navigate = useNavigate()
  const { showStatus } = useStatusPill()
  const [pending, setPending] = useState(false)

  useEffect(() => {
    if (!pending) return
    const timeout = setTimeout(() => (to ? navigate(to) : navigate(-1)), SHEET_EXIT_MS)
    return () => clearTimeout(timeout)
  }, [pending, navigate, to])

  return useCallback(
    (status: string) => {
      setPending(true)
      showStatus(status, SHEET_EXIT_MS + BACK_SETTLE_MS)
    },
    [showStatus]
  )
}
